import React from "react";
import ProjectCard from "./ProjectCard";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import { useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";

const Projects = ({ projects = [] }) => {
  const navigate = useNavigate();

  if (!projects.length) return null;

  return (
    <section className="py-12 sm:py-16 md:py-20 bg-[#EAF2FF] bg-gradient-to-b from-white to-[#EAF2FF]">
      <div className="max-w-[90rem] mx-auto px-4 sm:px-6 md:px-8">
        {/* Heading */}
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <p className="text-xs sm:text-sm md:text-base font-semibold text-blue-600 uppercase tracking-wide">
            Our Portfolio
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-[#5AA650] mt-2 sm:mt-3">
            Explore Our Projects in South India
          </h2>
          <p className="text-gray-600 mt-3 sm:mt-4 text-sm sm:text-base max-w-2xl mx-auto">
            Discover thoughtfully designed residential projects across South
            India featuring quality construction and community living.
          </p>
        </div>

        {/* Swiper Slider */}
        <Swiper
          modules={[Pagination, Autoplay]}
          pagination={{ clickable: true }}
          autoplay={{ delay: 4000, disableOnInteraction: false }}
          spaceBetween={30}
          grabCursor={true}
          breakpoints={{
            0: {
              slidesPerView: 1.05,
              spaceBetween: 20,
            },
            640: {
              slidesPerView: 1.5,
              spaceBetween: 25,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 40,
            },
          }}
          className="!overflow-visible"
        >
          {projects.map((project) => (
            <SwiperSlide key={project.project_id}>
              <div className="h-full">
                <ProjectCard project={project} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Learn More Button */}
        <div className="mt-10 flex justify-center">
          <button
            onClick={() => navigate("/projects")}
            className="px-6 sm:px-8 py-3 text-sm sm:text-base font-semibold bg-blue-600 text-white rounded-full shadow-md hover:bg-blue-700 transition"
          >
            Learn More Projects
          </button>
        </div>
      </div>
    </section>
  );
};

export default Projects;
